import { render, staticRenderFns } from "./_dialogs.vue?vue&type=template&id=48100eca&scoped=true&lang=pug&"
import script from "./_dialogs.vue?vue&type=script&lang=js&"
export * from "./_dialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48100eca",
  null
  
)

export default component.exports